import { apiClient } from "../client-api";
import { authHeader } from "../../_helpers";

export default {
  all() {
    return apiClient.get("sapp/v2/notifications", { headers: authHeader() });
  }
};
